import { Injectable } from '@angular/core';
import {
  NbToastrService,
  NbGlobalPhysicalPosition
} from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  constructor(private toastrService: NbToastrService) { }

  show(title: string, body: string, status: 'success'|'danger'|'warning'|'info') {
    this.toastrService.show(
      body,
      title,
      {
        status: status,
        destroyByClick: true,
        duration: 2000,
        hasIcon: false,
        position: NbGlobalPhysicalPosition.TOP_RIGHT,
        preventDuplicates: true
      });
  }
}
